// extracted by mini-css-extract-plugin
export default {"list":"LePkvnKFi4Hl6483xGHO"};